import axios from "axios";
import "devexpress-richedit/dist/dx.richedit.css";
import { LoadPanel, Popup } from "devextreme-react";
import "devextreme/dist/css/dx.light.css";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ColumnDropdown } from "../../../components/Dropdownn";
import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import { logOut } from "../../../components/Logout";
import { Toster } from "../../../components/Toster/Toster";
import { handleGetLocal } from "../../../services/auth-service";
import { formatDate } from "../../Dateapi/dateFormatter";
import { SendEmail } from "../HeaderPopupComponent/SendEmail";
import "./documentWizard.css";
import { DocumentWizardFunction } from "./DocumentWizardFunction";
import AddAsAttachment from "./DocumentWizardPopup/AddAsAttachment";
import DocumentWizardSubTab from "./DocumentWizardSubTab";
import DWRichEditComponent from "./DWRichEditComponent";
// import { htmlToBase64 } from "../../../utils/base64-conversion";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled, width }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
        width={width}
      />
    </>
  );
};

const DocumentWizard = () => {
  const { dynamicParticipatTab, documentWizardInfo } = useSelector((store) => store.participate);
  const ApiClass = new DocumentWizardFunction();
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState({
    reports: { name: "", id: "" },
    supervisors: { name: "", id: "" },
    showCourt: false,
  });
  const [reportsDropdownData, setReportsDropdownData] = useState([]);
  const [supervisorsDropdownData, setSupervisorsDropdownData] = useState([]);
  const [documentWizardOutputData, setDocumentWizardOutputData] = useState([]);
  const [childDocumentWizardOutputData, setChildDocumentWizardOutputData] = useState([]);
  const navigate = useNavigate();
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [prewviewtogal, setprewviewtogal] = useState(undefined);
  const [sendEmailPopup, setSendEmailPopup] = useState(false);
  const userinfo = documentWizardInfo?.userinfo;
  const personId = userinfo?.gPersonId;
  const documentWizardStorageKey = personId ? `documentWizard_${personId}` : null;
  const supervisorID = fields?.supervisors?.id;
  const [addAsAttachmentPopup, setAddAsAttachmentPopup] = useState(false);
  const [editToggle, setEditToggle] = useState(false);
  const [htmlData, setHtmlData] = useState();
  const [printhtmlData, setprintHtmlData] = useState();
  const [childHtmlData, setChildHtmlData] = useState();
  const [parametersFields, setParametersFields] = useState({});
  const rtfFileName = `${documentWizardInfo?.sOffenderNumber ? documentWizardInfo?.sOffenderNumber : ""} ${
    documentWizardInfo?.sLastFirst ? documentWizardInfo?.sLastFirst : ""
  }`;
  const [sharequeryshow, setsharequeryshow] = useState(false);
  const [selectedDocketsValidation, setSelectedDocketsValidation] = useState("");
  const [wizardRestored, setWizardRestored] = useState(false);
  const richEditRef = useRef(null);
  // const defaultBase64 =
  //   "PCFET0NUWVBFIGh0bWw+PGh0bWwgbGFuZz0iZW4iPjxoZWFkPjxtZXRhIGNoYXJzZXQ9IlVURi04Ij48bWV0YSBuYW1lPSJ2aWV3cG9ydCIgY29udGVudD0id2lkdGg9ZGV2aWNlLXdpZHRoLCBpbml0aWFsLXNjYWxlPTEuMCI+PC9oZWFkPjxib2R5PjxwIHN0eWxlPSJ0ZXh0LWFsaWduOiBsZWZ0OyBtYXJnaW4tdG9wOiAwaW47IG1hcmdpbi1ib3R0b206IDBpbjsgYm9yZGVyLXdpZHRoOiBpbml0aWFsOyBib3JkZXItc3R5bGU6IG5vbmU7IGJvcmRlci1jb2xvcjogaW5pdGlhbDsgZm9udC1mYW1pbHk6IENhbGlicmksIHNhbnMtc2VyaWY7IGZvbnQtc2l6ZTogMTQuNjY3cHg7IGNvbG9yOiByZ2IoMCwgMCwgMCk7Ij4mbmJzcDs8L3A+PC9ib2R5PjwvaHRtbD4=";
  const defaultBase64 = btoa(String.fromCharCode(...new TextEncoder().encode("{\\rtf1\\ansi\\deff0\\par }")));

  const [documentAsBase64, setdocumentAsBase64] = useState(defaultBase64);
  const [childdocumentAsBase64, setchilddocumentAsBase64] = useState();
  const pathname = handleGetLocal("pathURL");
  

  function htmlToBase64(html) {
    const utf8Bytes = new TextEncoder().encode(html);
    let binaryString = "";
    utf8Bytes.forEach((byte) => {
      binaryString += String.fromCharCode(byte);
    });
    return btoa(binaryString);
  }

  const rtfToBase64 = (rtf) => {
    // Convert RTF string to a Uint8Array (binary data)
    const byteArray = new Uint8Array(new TextEncoder().encode(rtf));

    // Convert the Uint8Array to a Base64 string
    let binaryString = "";
    const len = byteArray.byteLength;
    for (let i = 0; i < len; i++) {
      binaryString += String.fromCharCode(byteArray[i]);
    }

    return btoa(binaryString);
  };

  const handleSave = async () => {
  try {
    setLoading(true);
    const currentDocumentBase64 =
      await richEditRef.current?.getCurrentDocument();

    if (!currentDocumentBase64) {
      throw new Error("Unable to get current document from RichEdit.");
    }

    const addAsAttachmentData = {
      gRecordID: userinfo.gPersonId,
      rtf: currentDocumentBase64,
      sDescription: documentWizardOutputData?.sName,
      sFileName: documentWizardOutputData?.sName,
    };
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/attachments/add-attachment`,
      addAsAttachmentData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      }
    );

    setAddAsAttachmentPopup(true);
  } catch (err) {
    if (err?.response?.status === 401) {
      logOut();
      return;
    }

    const apiMessage =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to add attachment";

    setToastConfig({
      isVisible: true,
      message: apiMessage,
      type: "error",
    });

    setTimeout(() => {
      setToastConfig((prev) => ({
        ...prev,
        isVisible: false,
      }));
    }, 3000);
  } finally {
    setLoading(false);
  }
};

  const handlePrint = async () => {
    setprewviewtogal(false);
    await base64tohtml(rtfToBase64(htmlData));
    setprewviewtogal(true);
  };

  const buildUpdatedDocuments = (fieldValues) => {
    let updatedParentRtf = documentWizardOutputData?.sReportRtf;
    for (const key in fieldValues) {
      const escaped = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      updatedParentRtf = updatedParentRtf.replace(new RegExp(escaped, "g"), fieldValues[key] || key);
    }
    const updatedChildren = (childHtmlData || []).map((child) => {
      let updatedChildRtf = child.sReportRtf;

      for (const key in fieldValues) {
        const escaped = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        updatedChildRtf = updatedChildRtf.replace(new RegExp(escaped, "g"), fieldValues[key] || key);
      }

      return {
        gParentId: child.gParentId,
        sName: child.sName,
        sReportRtf: updatedChildRtf,
      };
    });

    return { updatedParentRtf, updatedChildren };
  };

  const convertRtfToHtml = (rtf) => {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/api/document-wizard/base64tohtml-conversion`,
      {
        base64: rtfToBase64(rtf),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      },
    );
  };

  const handlePrintAllDocuments = () => {
    setLoading(true);

    const printDocs = [];

    if (htmlData) {
      printDocs.push(htmlData);
    }

    if (Array.isArray(childHtmlData) && childHtmlData.length > 0) {
      childHtmlData.forEach((doc) => {
        if (doc?.sReportRtf) {
          printDocs.push(doc.sReportRtf);
        }
      });
    }

    Promise.all(printDocs.map((rtf) => convertRtfToHtml(rtf)))
      .then((responses) => {
        const combinedHtml = responses
          .map((res, index) => {
            const html = res?.data?.data || "";

            return `
            <div class="${index > 0 ? "page-break" : ""}">
              ${html}
            </div>
          `;
          })
          .join("");

        const printWindow = window.open("", "", "width=900,height=900");

        printWindow.document.open();
        printWindow.document.write(`
        <html>
          <head>
            <title>Print Document</title>
            <style>
              @media print {
                .page-break {
                  page-break-before: always;
                }

                body {
                  margin: 20px;
                }
              }
            </style>
          </head>
          <body>
            ${combinedHtml}
          </body>
        </html>
      `);

        printWindow.document.close();

        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 500);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          logOut();
        } else {
          setToastConfig({
            isVisible: true,
            type: "error",
            message: "Unable to print the document.",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const PrintDocument = () => {
    const printDiv = document.querySelector('div[title="Print"][aria-label="Print"]');
    if (printDiv) {
      // Trigger the click event
      printDiv.click();
    } else {
      console.error("Print div not found");
    }
  };

  useEffect(() => {
    if (documentWizardOutputData?.sName && prewviewtogal && printhtmlData) {
      printTableData();
      setprewviewtogal(false);
    }
  }, [printhtmlData, documentWizardOutputData?.sName, prewviewtogal]);
  useEffect(() => {
  ApiClass.getDocumentWizardSupervisorDropdown(navigate,setSupervisorsDropdownData,setLoading,);

  setFields((prev) => {
    if (prev?.supervisors?.id) {
      return prev;
    }

    return {
      ...prev,
      supervisors: {
        name: userinfo?.sPrimarySupervisorName,
        id: userinfo?.gPrimarySupervisorId,
      },
    };
  });

  setsharequeryshow(true);
  setSelectedDocketsValidation("");
}, []);

  useEffect(() => {
    if (fields?.showCourt === false) {
      ApiClass.getDocumentWizardDropdown(navigate, setReportsDropdownData, setLoading);
    }
  }, [fields?.showCourt]);
  useEffect(() => {
    if (!wizardRestored || !documentWizardStorageKey) return;

    const wizardState = {
      fields,
      documentWizardOutputData,
      childDocumentWizardOutputData,
      htmlData,
      childHtmlData,
      parametersFields,
    };

    sessionStorage.setItem(documentWizardStorageKey, JSON.stringify(wizardState));
  }, [
    wizardRestored,
    documentWizardStorageKey,
    fields,
    documentWizardOutputData,
    childDocumentWizardOutputData,
    htmlData,
    childHtmlData,
    parametersFields,
  ]);

  useEffect(() => {
    if (!documentWizardStorageKey) {
      setWizardRestored(true);
      return;
    }

    try {
      const savedWizard = sessionStorage.getItem(documentWizardStorageKey);

      if (savedWizard) {
        const saved = JSON.parse(savedWizard);

        if (saved.fields) {
          setFields(saved.fields);
        }

        if (saved.documentWizardOutputData) {
          setDocumentWizardOutputData(saved.documentWizardOutputData);
        }

        if (saved.childDocumentWizardOutputData) {
          setChildDocumentWizardOutputData(saved.childDocumentWizardOutputData);
        }

        if (saved.htmlData) {
          setHtmlData(saved.htmlData);
        }

        if (saved.childHtmlData) {
          setChildHtmlData(saved.childHtmlData);
        }

        if (saved.parametersFields) {
          setParametersFields(saved.parametersFields);
        }
      }
    } catch (error) {
      console.error("Unable to restore Document Wizard:", error);
    } finally {
      setWizardRestored(true);
    }
  }, [documentWizardStorageKey]);

  const getDocumentWizardUpdateRtfDocument = async (parentRtf, childDocs = []) => {
    await ApiClass.getDocumentWizardUpdateRtfDocument(
      navigate,
      {
        personID: personId,
        rtf: parentRtf,
        selectedDockets: [],
        supervisorID: supervisorID,
      },
      setLoading,
      setParametersFields,
    );
    for (const child of childDocs) {
      await ApiClass.getDocumentWizardUpdateRtfDocument(
        navigate,
        {
          personID: personId,
          rtf: child.sReportRtf,
          selectedDockets: [],
          supervisorID: supervisorID,
        },
        setLoading,
        setParametersFields,
      );
    }
  };

  useEffect(() => {
  if (!wizardRestored) return;
  if (!fields?.reports?.id) return;
  if (
    documentWizardOutputData?.gReportCatalogID === fields.reports.id &&
    htmlData
  ) {
    return;
  }

  setChildHtmlData(undefined);
  setParametersFields({});

  ApiClass.getDocumentWizardData(
    fields.reports.id,
    navigate,
    setDocumentWizardOutputData,
    setChildDocumentWizardOutputData,
    setHtmlData,
    setChildHtmlData,
    setLoading,
    async (parentRtf) => {
      await ApiClass.getDocumentWizardUpdateRtfDocument(
        navigate,
        {
          personID: personId,
          rtf: parentRtf,
          selectedDockets: [],
          supervisorID: fields?.supervisors?.id,
        },
        setLoading,
        setParametersFields,
      );
    },
    documentWizardOutputData,
  );
}, [fields?.reports?.id, wizardRestored]);

  useEffect(() => {
    if (!Object.keys(parametersFields).length) return;
    if (!Array.isArray(childDocumentWizardOutputData)) return;

    setChildHtmlData(
      childDocumentWizardOutputData.map((child) => {
        let updatedRtf = child.sReportRtf;

        Object.entries(parametersFields).forEach(([key, value]) => {
          const escaped = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
          updatedRtf = updatedRtf.replace(new RegExp(escaped, "g"), value || key);
        });

        return {
          ...child,
          sReportRtf: updatedRtf,
        };
      }),
    );
  }, [parametersFields, childDocumentWizardOutputData]);

  useEffect(() => {
    if (Array.isArray(childDocumentWizardOutputData) && childDocumentWizardOutputData.length > 0) {
      (async () => {
        for (const child of childDocumentWizardOutputData) {
          await ApiClass.getDocumentWizardUpdateRtfDocument(
            navigate,
            {
              personID: personId,
              rtf: child.sReportRtf,
              selectedDockets: [],
              supervisorID: supervisorID,
            },
            setLoading,
            setParametersFields,
          );
        }
      })();
    }
  }, [childDocumentWizardOutputData]);

  useEffect(() => {
    if (fields?.supervisors?.id) {
      setParametersFields((prev) => ({
        ...prev,
        "[SupervisorName]": fields?.supervisors?.name,
      }));
    }
  }, [fields?.supervisors?.id]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFields((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const documentWizardSaveData = {
    gReportCatalogID: fields?.reports?.id,
    // report: base64ToHtml(documentAsBase64),
    report: documentAsBase64,
  };

  const base64tohtml = async (base64data) => {
    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/document-wizard/base64tohtml-conversion`,
        { base64: base64data },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      )
      .then((val) => {
        setprintHtmlData(val?.data?.data);
      })
      .catch((val) => {
        setLoading(false);
        if (val?.response?.status === 401) {
          logOut();
        } else {
          if (val?.response?.status) {
            navigate(`/error/500`);
          } else {
            navigate("/error/500");
          }
        }
      });
  };
  const printTableData = () => {
    var printWindow = window.open("", "", "width=600,height=600");
    printWindow.document.open();

    printWindow.document.write(`
      <html>
      <head>
        <title>Document Wizard</title>
        <style>
          /* Add your CSS styles here */
        </style>
      </head>
      <body>
        <div>${printhtmlData}</div>
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const extractBracketParams = (rtf) => {
    if (!rtf) return [];
    const regex = /\[([^\]]+)\]/g;
    const matches = new Set();
    let match;

    while ((match = regex.exec(rtf)) !== null) {
      matches.add(`[${match[1]}]`);
    }
    return Array.from(matches);
  };

  const findParameterHtmlData = () => {
    if (!documentWizardOutputData?.sReportRtf) return;
    const currentDate = new Date();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const year = currentDate.getFullYear();
    const currentDateString = formatDate(currentDate);
    const autoFillMap = {
      "[UpperOffenderName]": userinfo?.sFirstLast || "",
      "[UpperOffenderAddressList]": userinfo?.sHomeAddressBlock || "",
      "[SupervisorName]": fields?.supervisors?.name || "",
      "[CurrentYear]": year.toString(),
      "[CurrentDate]": currentDateString,
      "[Currentdate]": currentDateString,
    };
    const parentParams = extractBracketParams(documentWizardOutputData?.sReportRtf);
    const childParams =childDocumentWizardOutputData?.flatMap((child) => extractBracketParams(child?.sReportRtf)) || [];
    const allParams = Array.from(new Set([...parentParams, ...childParams]));
    const paramsObject = {};
    allParams.forEach((param) => {
      paramsObject[param] = autoFillMap[param] ?? "";
    });

    // setParametersFields((prev) => ({
    //   ...prev,
    //   ...paramsObject,
    // }));
    setParametersFields(paramsObject);
  };

  useEffect(() => {
    if (documentWizardOutputData || childDocumentWizardOutputData?.length) {
      findParameterHtmlData();
    }
  }, [documentWizardOutputData, childDocumentWizardOutputData]);

  const replaceFieldsWithValues = (fieldValues) => {
    var html2 = documentWizardOutputData?.sReportRtf;
    for (const fieldName in fieldValues) {
      const fieldValue = fieldValues[fieldName];
      var replacement = fieldValue ? fieldValue : fieldName;
      var escapedPattern = fieldName?.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var regex = new RegExp(escapedPattern, "g");
      html2 = html2?.replace(regex, replacement);
    }
    setHtmlData(html2);
    if (childHtmlData) {
      changeChildDocument(fieldValues);
    }
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      message: "Successfully Updated!",
      type: "success",
    });
    setTimeout(() => {
      setToastConfig({
        ...toastConfig,
        isVisible: false,
        message: "Successfully Updated!",
        type: "success",
      });
    }, 1900);
  };

  const changeChildDocument = (fieldValues) => {
    setChildHtmlData((prev) => {
      const source =
        Array.isArray(prev) && prev.length
          ? prev
          : Array.isArray(childDocumentWizardOutputData)
            ? childDocumentWizardOutputData
            : [];

      return source
        .filter((item) => typeof item?.sReportRtf === "string")
        .map((item) => {
          let updatedRtf = item.sReportRtf;

          for (const fieldName in fieldValues) {
            const fieldValue = fieldValues[fieldName];
            const replacement = fieldValue || fieldName;
            const escaped = fieldName.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            const regex = new RegExp(escaped, "g");

            updatedRtf = updatedRtf.replace(regex, replacement);
          }

          return {
            ...item,
            sReportRtf: updatedRtf,
          };
        });
    });
  };

  useEffect(() => {
    if (
      Array.isArray(childDocumentWizardOutputData) &&
      childDocumentWizardOutputData.length &&
      !Array.isArray(childHtmlData)
    ) {
      setChildHtmlData(childDocumentWizardOutputData);
    }
  }, [childDocumentWizardOutputData]);

  const handleExportToRTF = async () => {
  setLoading(true);

  try {
    const currentDocumentBase64 =
      await richEditRef.current?.getCurrentDocument();

    if (!currentDocumentBase64) {
      throw new Error("Unable to get current document from RichEdit.");
    }

    const documents = [];
    documents.push(currentDocumentBase64);
    if (Array.isArray(childHtmlData) && childHtmlData.length > 0) {
      childHtmlData.forEach((child) => {
        if (child?.sReportRtf) {
          documents.push(rtfToBase64(child.sReportRtf));
        }
      });
    }

    const payload = {
      documents,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/document-wizard/merge-rtf-documents`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      }
    );

    const mergedBase64 = response?.data?.data;

    if (!response?.data?.isSuccess || !mergedBase64) {
      throw new Error(
        response?.data?.message || "Unable to merge documents."
      );
    }
    const binaryString = atob(mergedBase64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], {
      type: "application/rtf",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `${rtfFileName}.rtf`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Merge RTF export error:", err);

    if (err?.response?.status === 401) {
      logOut();
      return;
    }

    const apiMessage =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Unable to export the document.";

    setToastConfig({
      isVisible: true,
      type: "error",
      message: apiMessage,
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Popup
        visible={sendEmailPopup}
        onHiding={() => {
          setSendEmailPopup(false);
        }}
        showTitle={false}
        width={1180}
        height={860}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <SendEmail
          recivePaymentModel={sendEmailPopup}
          setRecivePaymentModel={setSendEmailPopup}
          userinfo={userinfo}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          documentWizrard={true}
        />
      </Popup>
      <Popup
        visible={addAsAttachmentPopup}
        onHiding={() => {
          setAddAsAttachmentPopup(false);
        }}
        showTitle={false}
        width={650}
        height={200}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddAsAttachment
          addAsAttachmentPopup={addAsAttachmentPopup}
          setAddAsAttachmentPopup={setAddAsAttachmentPopup}
          userinfo={userinfo}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          setLoading={setLoading}
          navigate={navigate}
          fields={fields}
          htmlData={htmlData}
          documentWizardOutputData={documentWizardOutputData}
        />
      </Popup>
      <div className="particcipentPage">
        <DynamicTabb />
        <div className="document-wizard-page-section">
          <div className="document-wizard-info-section">
            <div className="document-wizard-info-part">
              <div className="page-content document-wizard-page">
                <p className="page-info-text-detail">
                  {documentWizardInfo?.sOffenderNumber ? documentWizardInfo?.sOffenderNumber : ""}
                  &#160;-&#160;
                  {documentWizardInfo?.sLastFirst ? documentWizardInfo?.sLastFirst : ""}
                </p>
                <div className="document-wizard-content">
                  <div className="document-wizard-content-left">
                    <div className="display-flex-div">
                      <input
                        type="checkbox"
                        name="showCourt"
                        id="showCourt"
                        value={fields?.showCourt}
                        onChange={handleChange}
                      />
                      <label htmlFor="showCourt" className="fee-payment-content-info-para">
                        Show Court Specific Documents Only
                      </label>
                    </div>
                    <div className="display-flex-div">
                      <div className="report-dropdown">
                        <DropDown
                          setfields={setFields}
                          fields={fields}
                          fieldNmae={"reports"}
                          dropDownData={reportsDropdownData}
                          width={400}
                          // disabled={fields?.showCourt}
                        />
                      </div>
                    </div>
                    <p className="error_validation">{selectedDocketsValidation}</p>
                    <div className="display-flex-div">
                      <DropDown
                        setfields={setFields}
                        fields={fields}
                        fieldNmae={"supervisors"}
                        dropDownData={supervisorsDropdownData}
                        width={400}
                      />
                    </div>
                  </div>
                  <div className="document-wizard-content-right">
                    <div className="buttons document-wizard-buttons">
                      <button
                        className="btn"
                        onClick={async () => {
                          if (!htmlData) return;
                          const { updatedParentRtf, updatedChildren } = buildUpdatedDocuments(parametersFields);

                          setHtmlData(updatedParentRtf);
                          setChildHtmlData(updatedChildren);
                          await ApiClass.getDocumentWizardUpdateRtfDocument(
                            navigate,
                            {
                              personID: personId,
                              supervisorID: supervisorID,
                              selectedDockets: [],
                              rtf: updatedParentRtf,
                            },
                            setLoading,
                            setParametersFields,
                          );

                          for (const child of updatedChildren) {
                            await ApiClass.getDocumentWizardUpdateRtfDocument(
                              navigate,
                              {
                                personID: personId,
                                supervisorID: supervisorID,
                                selectedDockets: [],
                                rtf: child.sReportRtf,
                              },
                              setLoading,
                              setParametersFields,
                            );
                          }
                        }}
                      >
                        Update
                      </button>
                      <button
                        className="btn"
                        onClick={() => {
                          if (htmlData) {
                            // handleExportToPDF();
                            handleExportToRTF();
                          }
                        }}
                      >
                        Export
                      </button>
                      <button className="btn" onClick={handleSave} disabled={!fields?.reports?.id}>
                        Add as Attachment
                      </button>
                      <button
                        className="btn"
                        onClick={() => {
                          setSendEmailPopup(true);
                        }}
                      >
                        Send as Email
                      </button>
                      <button
                        className="btn"
                        //  onClick={handlePrint}
                        onClick={handlePrintAllDocuments}
                      >
                        Print
                        <svg
                          className="svg-blue-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_5985_7014)">
                            <path
                              d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
                              fill="#424167"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5985_7014">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <DocumentWizardSubTab
                documentWizardInfo={documentWizardInfo}
                loading={loading}
                setLoading={setLoading}
                editToggle={editToggle}
                documentWizardOutputData={documentWizardOutputData}
                htmlData={htmlData}
                setHtmlData={setHtmlData}
                parametersFields={parametersFields}
                setParametersFields={setParametersFields}
                sharequeryshow={sharequeryshow}
                personId={personId}
                setSelectedDocketsValidation={setSelectedDocketsValidation}
                fields={fields}
                changeChildDocument={changeChildDocument}
                childHtmlData={childHtmlData}
                setReportsDropdownData={setReportsDropdownData}
              />
            </div>
            <div className="document-wizard-output">
              {htmlData && (
                <DWRichEditComponent
                  // key={documentWizardOutputData?.gReportCatalogID}
                  ref={richEditRef}
                  key={fields?.reports?.id}
                  documentWizardOutputData={documentWizardOutputData}
                  // documentAsRtf={documentWizardOutputData?.sReportRtf}
                  documentAsRtf={htmlData}
                  documentName={documentWizardOutputData?.sName}
                  setdocumentAsBase64={setdocumentAsBase64}
                  childDocumentWizardOutputData={childDocumentWizardOutputData}
                  // childdocumentAsBase64={childdocumentAsBase64}
                  // setchilddocumentAsBase64={setchilddocumentAsBase64}
                  childHtmlData={childHtmlData}
                  setChildHtmlData={setChildHtmlData}
                  editToggle={editToggle}
                  setHtmlData={setHtmlData}
                  // updatedocumentAsBase64={updatedocumentAsBase64}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentWizard;
